import React from 'react'
import Label from './Label'
import { commonColors } from '@linqpal/common-frontend/src/theme/colors'

type Props = {
  children?: React.ReactNode
  color?: string
  style?: any
  testID?: any
}

export default ({
  children,
  color,
  style = {},
  testID = 'error-text',
}: Props) =>
  children ? (
    <Label color={color || commonColors.accent} style={style} testID={testID}>
      {children}
    </Label>
  ) : null
